import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import SVG from 'react-inlinesvg';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import PromoBannerCard from './promo-banner-card/PromoBannerCard';
import 'swiper/css';
import 'swiper/css/navigation';
import { useDeviceScreen } from '@lib/layouts/DeviceScreenProvider';
import classNames from 'classnames';
import styles from './PromoBannerSlider.module.scss';
const PromoBannerSlider = t0 => {
  const $ = _c(32);
  const {
    promoCards
  } = t0;
  const [swiperInstance, setSwiperInstance] = useState(null);
  const {
    isMobile
  } = useDeviceScreen();
  const hasLoopSlideEffect = promoCards.length > 3 || isMobile;
  const promoCardsMinimunLength = promoCards.length <= 3;
  let t1;
  if ($[0] !== swiperInstance) {
    t1 = () => swiperInstance?.slidePrev();
    $[0] = swiperInstance;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handlePrevSlide = t1;
  let t2;
  if ($[2] !== swiperInstance) {
    t2 = () => swiperInstance?.slideNext();
    $[2] = swiperInstance;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleNextSlide = t2;
  let t3;
  if ($[4] !== promoCardsMinimunLength) {
    t3 = classNames(styles.navigationButtonPrev, {
      [styles.buttonDisabled]: promoCardsMinimunLength
    });
    $[4] = promoCardsMinimunLength;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SVG src="images/svg/arrow-prev.svg" />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== handlePrevSlide || $[8] !== t3) {
    t5 = <button onClick={handlePrevSlide} className={t3}>{t4}</button>;
    $[7] = handlePrevSlide;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== promoCardsMinimunLength) {
    t6 = classNames(styles.navigationButtonNext, {
      [styles.buttonDisabled]: promoCardsMinimunLength
    });
    $[10] = promoCardsMinimunLength;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <SVG src="images/svg/arrow-next.svg" />;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== handleNextSlide || $[14] !== t6) {
    t8 = <button onClick={handleNextSlide} className={t6}>{t7}</button>;
    $[13] = handleNextSlide;
    $[14] = t6;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t5 || $[17] !== t8) {
    t9 = <div className={styles.navigationButtons}>{t5}{t8}</div>;
    $[16] = t5;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      el: `.${styles.paginationPoints}`,
      clickable: true,
      renderBullet: _temp
    };
    t11 = swiper => {
      setSwiperInstance(swiper);
    };
    $[19] = t10;
    $[20] = t11;
  } else {
    t10 = $[19];
    t11 = $[20];
  }
  let t12;
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = [Navigation, Pagination, Autoplay];
    t13 = {
      delay: 4000,
      pauseOnMouseEnter: true
    };
    $[21] = t12;
    $[22] = t13;
  } else {
    t12 = $[21];
    t13 = $[22];
  }
  let t14;
  if ($[23] !== promoCards) {
    t14 = promoCards.map(_temp2);
    $[23] = promoCards;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className={styles.paginationPoints} />;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== hasLoopSlideEffect || $[27] !== t14) {
    t16 = <Swiper className={styles.swiper} slidesPerView="auto" speed={1000} pagination={t10} onSwiper={t11} loop={hasLoopSlideEffect} modules={t12} autoplay={t13}>{t14}{t15}</Swiper>;
    $[26] = hasLoopSlideEffect;
    $[27] = t14;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t16 || $[30] !== t9) {
    t17 = <div className={styles.root}>{t9}{t16}</div>;
    $[29] = t16;
    $[30] = t9;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  return t17;
};
export default PromoBannerSlider;
function _temp(_, className) {
  return `<span class="${className}"></span>`;
}
function _temp2(promoCard) {
  return <SwiperSlide key={promoCard.id} className={styles.slide}><PromoBannerCard promoCard={promoCard} /></SwiperSlide>;
}